import { useLoaderData, useNavigate, useRouteError } from "react-router-dom";
import "./styles.css";
import GenericErrorDisplay from "../generic-error";
import ResourceDisplay from "../../components/resource-display";
import ButtonPrimary from "../../components/button-primary/index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import ResourceService from "../../service/resource";

export const path = "/in-construction";

const resourceKeys = {
  image: "in-construction-image",
};

export async function loader({ request }) {
  return await new ResourceService().read.byIds(Object.values(resourceKeys));
}

export function Component() {
  const resources = useLoaderData();
  const navigate = useNavigate();

  return (
    <div id="in-construction">
      <div className="text-container">
        <h1>În lucru...</h1>
        <h4>Pagina va fi disponibilă în curând</h4>
        <ButtonPrimary onClick={() => navigate(-1)} className="button">
          <FontAwesomeIcon icon={faChevronLeft} />
          Înapoi
        </ButtonPrimary>
      </div>
      <ResourceDisplay
        resource={resources[resourceKeys.image]}
        className="image-container"
      />
    </div>
  );
}
Component.displayName = "page-in-constructie";

export function ErrorBoundary() {
  const error = useRouteError();
  return <GenericErrorDisplay error={error} />;
}
ErrorBoundary.displayName = "page-in-constructie-error";
